import Layout from "modules/claims/components/Layout"
import { FormattedMessage, useIntl } from "react-intl"
import { useLocation } from "react-router-dom"
import "../styles/step-form.scss"
import bgHero from "../../Layout/assets/img/hero.png"
import ProgressBar from "../ProgressBar"
import { URL_SPRADLING_HOME } from "./constants"
import COMPONENT_TRANSLATIONS from "./constants/translationsMessages"

const formatEmails = (email) => {
  if (Array.isArray(email)) return email.join(", ")
  return email
}

const ThankYou = () => {
  const { state: createdClaim } = useLocation()

  const intl = useIntl()

  return (
    <Layout
      title={
        <FormattedMessage
          id="Claims.ThankYou.title"
          description="section claim thank you title"
          defaultMessage="Thank you!"
        />
      }
      alignDescription="center"
      backgroundImage={bgHero}
    >
      <div>
        <p className="step-form--label">
          <FormattedMessage
            id="Claims.ThankYou.description"
            description="section claim thank you description"
            defaultMessage="Your claim has been submitted and will be processed. Please allow 5-10 working days for an initial feedback. A Customer Service Representative will contact you.{br}{br}Your claim reference number is: <strong>{ticket}</strong> {br}{br}Please indicate this number in all correspondence related with this claim.{br}{br} A copy of your claim registration will be sent to {email}"
            values={{
              email: formatEmails(createdClaim?.email),
              ticket: createdClaim?.claimNominaId,
              br: <br />,
              strong: (...chunks) => <strong>{chunks}</strong>
            }}
          />
        </p>
      </div>
      <div className="btn-container">
        <a href={URL_SPRADLING_HOME} target="_self" className="btn btn-dark w-50">{intl.formatMessage(COMPONENT_TRANSLATIONS.btn_spradling_home)}</a>
      </div>
      <ProgressBar progress={100} />
    </Layout>
  )
}

export default ThankYou
